import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { sourceAppValues } from '../types';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Messaging = ({
  langPath,
  showCta,
  redirectUrl,
  source
}) => /*#__PURE__*/_jsxs(ButtonWrapper, {
  children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: langPath.body,
    elements: {
      UILink: Link
    }
  }), showCta ? /*#__PURE__*/_jsx(Button, {
    use: "tertiary",
    size: "small",
    "aria-label": text(langPath.cta),
    "data-testid": "suspension-banner-cta-button",
    "data-test-id": "suspension-banner-cta-button",
    href: redirectUrl || `/account-verification/${PortalIdParser.get()}?sourceURL=${source}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langPath.cta
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {})]
});
Messaging.propTypes = {
  source: PropTypes.oneOf(sourceAppValues)
};
export default Messaging;